import { Checkbox, Col, Row, TimePicker } from "antd";
import React from "react";
import "../styles.css";
// import moment from 'moment'

const spanstyles = {
  marginRight: 8,
};

export const getAnnotationSettingsDefaultConfigs = {
  annotation_set_retention: false,
  annotation_edit_retention: false,
  annotation_cutoff: false,
  annotation_cutoff_time: undefined,
};

function AnnotationSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "annotation_set_retention"
                )
              }
              checked={props.config.annotation_set_retention}
            />
          </span>
          <span style={spanstyles}>Set Retention</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "annotation_edit_retention"
                )
              }
              checked={props.config.annotation_edit_retention}
            />
          </span>
          <span style={spanstyles}>Edit Retention</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "annotation_cutoff"
                )
              }
              checked={props.config.annotation_cutoff}
            />
          </span>
          <span style={spanstyles}>Annotation Cut-Off Time</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <TimePicker
            value={props.config.annotation_cutoff_time}
            onChange={(e) =>
              props.updateValue(e, props._id, "annotation_cutoff_time")
            }
          />
        </Col>
      </Row>
    </div>
  );
}

export default React.memo(AnnotationSettings);
